"use client";
import { Box, Typography, Container, IconButton, Paper } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos, LocationOn } from "@mui/icons-material";
import Image from "next/image";
import { useState } from "react";
import Dr_Ahmad_Rafee_Che_Kassim from "../../../images/Dr Ahmad Rafee Che Kassim.jpg";
import MR_MIKE_THIRUMAN from "../../../images/MR MIKE THIRUMAN.jpg";
import Rhodora_Angela from "../../../images/Rhodora Angela.png";
import Muhammad from "../../../images/Muhammad.png";
import nguyensonghung from "../../../images/nguyensonghung.jpg";

// Dummy data for demonstration
const judges = [
  {
    name: "Dr Ahmad Rafee Che Kassim",
    country: "Malaysia",
    image: Dr_Ahmad_Rafee_Che_Kassim,
    profile1:
      `Dr Ahmad Rafee Che Kassim earned his B.Sc. Ed in Biology (University of Malaya), M.Sc in Management Science (Universiti Utara Malaysia), and PhD in Information Science and Learning Technology (University of Missouri-Columbia, USA).`,
    profile2:
      `He has served at the Ministry of Education Malaysia for 31 years. He started his career as a schoolteacher in 1993 and held several important positions in teaching and leadership roles in school and then at Institut Aminudin Baki (IAB), the National Institute of Educational Leadership and Management. He also served as the Director of Educational Policy, Planning, Research and Development (EPRD), and was promoted as the Deputy Director General of Education Malaysia in 2019 before retiring in 2024. He is a main advocate of innovation in teaching and learning, digital education and STEM education in Malaysia, and has spearheaded many strategic initiatives in the country throughout his career. He was appointed as Adjunct Professor at Universiti Teknologi Malaysia (2022-2024) and Universiti Kebangsaan Malaysia (2023-2025).
`,
  },
  // {
  //   name: "MR MIKE THIRUMAN",
  //   country: "Singapore",
  //   image: MR_MIKE_THIRUMAN,
  //   profile1:
  //     `Mike Thiruman is the General Secretary of the Singapore Teachers’ Union (STU) and a member of the National Trades Union Congress, Singapore (NTUC) Central Committee. Mike was elected into STU’s Central Council in 1999, and was elected as the STU President in October 2003 and as its the General Secretary in July 2017.`,
  //   profile2:
  //     `Mike has been active in the NTUC since 2001. He has taken on several roles in various committees. Currently, Mr Thiruman is the NTUC Essential Domestic Service Cluster Chairman and Public Service Cluster Co-Chairman.  Mike was appointed to the UN High-Level Panel on the Teaching Profession in 2023.`,
  // },
  {
    name: `Dr. Rhodora Angela "Doris" Fernandez Ferrer`,
    country: "Philippines",
    image: Rhodora_Angela,
    profile1:
      `Dr. Rhodora Angela "Doris" Fernandez Ferrer is the distinguished Executive Director of the Private Education Assistance Committee (PEAC) in the Philippines. With a Ph.D. in Education (Educational Leadership and Management) from De La Salle University and executive education from the Lee Kuan Yew School of Public Policy, Dr. Ferrer brings extensive expertise to educational policy and private sector engagement.`,
    profile2:
      `Her impactful career includes 18 years at St. Scholastica's College in various leadership roles and serving as Executive Director of the Catholic Educational Association of the Philippines (CEAP), where she was instrumental in the K to 12 program implementation. At PEAC, she manages pivotal national programs like the Education Service Contracting and SHS Voucher Program, significantly impacting thousands of teachers annually through in-service training. Dr. Ferrer also spearheads partnerships for advanced school leadership training and chairs the influential Philippine Education Conference. Recognized as a PNU Distinguished Alumna and a recipient of The Outstanding Fernandino Award, her work underscores a profound commitment to advancing Philippine education through innovation and strategic partnerships.`,
  },
  {
    name: `Dr. Muhammad Muchlas Rowi`,
    country: "Indonesia",
    image: Muhammad,
    profile1:
      `Dr. Muhammad Muchlas Rowi is a dynamic leader with over 25 years of experience at the nexus of sports governance, corporate oversight, and education advocacy. As Chairman of the Indonesia Traditional Karate Federation (INATKF) and Secretary-General of the International Traditional Karate Federation (ITKF) for Asia & Oceania, he has propelled Indonesian athletes to numerous international gold medals and secured INATKF’s full KORMI recognition. He actively represents ITKF at global forums like the TAFISA World Congress, fostering collaboration with partners including the IOC, UNESCO, and WHO to promote 'Sport for All.'`,
    profile2:
      `Beyond sports, Dr. Rowi serves as an Independent Commissioner at PT Jaminan Kredit Indonesia (Jamkrindo), where he champions IT governance to improve MSME financial accessibility. A dedicated Muhammadiyah activist, he is Deputy Treasurer II of its Council for Higher Education and Research, addressing crucial issues like Indonesia's tertiary gross enrolment ratio. His multifaceted expertise is anchored by PhDs in Law and Theology, a Master's in Management, and a Bachelor's in Philosophy.`,
  },
  {
    name: `Mr Nguyễn Song Hùng`,
    country: "Vietnam",
    image: nguyensonghung,
    profile1:
      `Nguyễn Song Hùng is a highly respected Senior Officer at the Ministry of Education and Training (MOET) of Vietnam, with an influential career spanning nearly four decades. For over 20 years, he has been a driving force behind national education reform, spearheading initiatives in English language programs and the integration of STEM/STEAM methodologies into the primary curriculum.`,
    profile2:
      `As a distinguished curriculum specialist, Mr. Hùng has played a pivotal role in developing Vietnam's national English curriculum and has authored over 20 widely used textbooks on English language teaching and assessment for young learners. He is a prominent national examiner for English competitions and a sought-after expert in innovative assessment and child-friendly educational approaches. His work, which combines deep policy knowledge with practical classroom application, has significantly shaped the learning journeys of a generation of students and educators across Vietnam. He holds an M.A. in TESOL and has received extensive training in educational management from international organizations.`,
  },
];

export default function JudgesSection() {
  const [index, setIndex] = useState(0);
  const currentJudge = judges[index];

  const handlePrev = () => setIndex((prev) => (prev === 0 ? judges.length - 1 : prev - 1));
  const handleNext = () => setIndex((prev) => (prev === judges.length - 1 ? 0 : prev + 1));

  return (
    <Container sx={{ py: 6, textAlign: "center", maxWidth: "600" }} id="judges">
       <Typography
        variant="h4"
        sx={{
          mb: 4,
          fontWeight: 600,
          color: "#3f51b5",
          fontSize: { xs: "1.75rem", sm: "2.125rem" },
        }}
      >
        Meet the Judges
      </Typography>

      <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, borderRadius: 4, position: "relative" }}>
        <Box
          sx={{
            position: "relative",
            width: { xs: "100%", sm: 400 },
            height: { xs: 300, sm: 400 },
            mb: 3,
            borderRadius: 2,
            overflow: "hidden",
            mx: "auto",
          }}
        >
          <Box
            component="img"
            src={currentJudge.image}
            alt={currentJudge.name}
            sx={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        </Box>

        <Typography
          variant="h6"
          sx={{ fontWeight: 600, fontSize: { xs: "1.1rem", sm: "1.5rem" } }}
        >
          {currentJudge.name}
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "text.secondary",
            mb: 2,
            mt: 0.5,
            flexWrap: "wrap",
          }}
        >
          <LocationOn sx={{ fontSize: 20, mr: 0.5 }} />
          <Typography variant="body2" sx={{ fontSize: { xs: "0.9rem", sm: "1rem" } }}>
            {currentJudge.country}
          </Typography>
        </Box>

        <Typography
          variant="body2"
          sx={{ fontSize: { xs: "0.95rem", sm: "1.05rem" }, lineHeight: 1.6, textAlign: "left", mb: 2 }}
        >
          {currentJudge.profile1}
        </Typography>

        <Typography
          variant="body2"
          sx={{ fontSize: { xs: "0.95rem", sm: "1.05rem" }, lineHeight: 1.6, textAlign: "left" }}
        >
          {currentJudge.profile2}
        </Typography>

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: { xs: 8, sm: -40 },
            transform: "translateY(-50%)",
          }}
        >
          <IconButton onClick={handlePrev} size="large" sx={{ bgcolor: "#f5f5f5" }}>
            <ArrowBackIos fontSize="small" />
          </IconButton>
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: "50%",
            right: { xs: 8, sm: -40 },
            transform: "translateY(-50%)",
          }}
        >
          <IconButton onClick={handleNext} size="large" sx={{ bgcolor: "#f5f5f5" }}>
            <ArrowForwardIos fontSize="small" />
          </IconButton>
        </Box>
      </Paper>
    </Container>
  );
}
